import api from './api';

const BASE = '/sales';

const salesPipelineService = {
  // Stages
  getStages: (params) => api.get(`${BASE}/stages`, { params }).then(r => r.data),
  getStageById: (id) => api.get(`${BASE}/stages/${id}`).then(r => r.data),
  createStage: (data) => api.post(`${BASE}/stages`, data).then(r => r.data),
  updateStage: (id, data) => api.put(`${BASE}/stages/${id}`, data).then(r => r.data),
  deleteStage: (id) => api.delete(`${BASE}/stages/${id}`).then(r => r.data),

  // Opportunities
  getOpportunities: (params) => api.get(`${BASE}/opportunities`, { params }).then(r => r.data),
  getOpportunityById: (id) => api.get(`${BASE}/opportunities/${id}`).then(r => r.data),
  createOpportunity: (data) => api.post(`${BASE}/opportunities`, data).then(r => r.data),
  updateOpportunity: (id, data) => api.put(`${BASE}/opportunities/${id}`, data).then(r => r.data),
  deleteOpportunity: (id) => api.delete(`${BASE}/opportunities/${id}`).then(r => r.data),

  // Activities
  getActivities: (id) => api.get(`${BASE}/opportunities/${id}/activities`).then(r => r.data),
  addActivity: (id, data) => api.post(`${BASE}/opportunities/${id}/activities`, data).then(r => r.data),

  // Pipeline summary
  getPipelineSummary: () => api.get(`${BASE}/pipeline-summary`).then(r => r.data),

  // Reports
  getPipelineByStage: () => api.get(`${BASE}/pipeline-report/by-stage`).then(r => r.data),
  getWinLossCount: () => api.get(`${BASE}/pipeline-report/win-loss`).then(r => r.data),
  getOwnerPerformance: () => api.get(`${BASE}/pipeline-report/owner-performance`).then(r => r.data)
};

export default salesPipelineService;
